export default __webpack_public_path__ + "static/media/Young-Ju-Kim.d07c9cad.png";